// extracted by mini-css-extract-plugin
export var container = "_df-0";